<template>
  <a href="#" @click.prevent="create" class="gif-create">
    <span v-if="!isCreating">
      {{ $t('detail.download_gif') }}
    </span>
    <v-progress-circular
      v-else
      indeterminate
      color="#5a7bff"
      class="gif-create-loader"
    ></v-progress-circular>
  </a>
</template>

<script>
import gifshot from 'gifshot'
import mergeImages from 'merge-images'
import download from 'downloadjs'

export default {
  props: {
    graduate: Object
  },
  data() {
    return {
      src: null,
      isCreating: false,
      attempts: 0
    }
  },
  methods: {
    create() {
      this.isCreating = true
      var self = this

      const images = this.graduate.pictures_list.map(src => {
        return src.replace(
          'public://pictures',
          'https://api.frogfish.dev/sites/default/files/styles/portrait/public/pictures'
        )
      })

      const merges = []

      images.forEach(image => {
        merges.push(
          mergeImages(
            [
              'https://api.frogfish.dev/sites/default/files/gif/background.png',
              {
                src: image,
                x: 85,
                y: 25
              },
              {
                src: `https://api.frogfish.dev/sites/default/files/gif/texture_${Math.floor(
                  Math.random() * 4
                )}.jpg`,
                opacity: 0.4,
                x: 85,
                y: 25
              },
              `https://api.frogfish.dev/sites/default/files/gif/${this.graduate.diploma}.png`
            ],
            {
              crossOrigin: 'Anonymous'
            }
          )
        )
      })

      Promise.all(merges)
        .then(values => {
          gifshot.createGIF(
            {
              images: values,
              interval: '0.5',
              gifWidth: '510',
              gifHeight: '630',
              sampleInterval: 1
            },
            function(obj) {
              self.isCreating = false
              if (!obj.error) {
                download(obj.image, 'remisetitres.gif', 'image/gif')
              }
            }
          )
        })
        .catch(() => {
          this.attempts++
          if (this.attempts < 4) {
            setTimeout(() => {
              this.create()
            }, 1000)
          } else {
            this.isCreating = false
          }
        })
    }
  }
}
</script>

<style lang="scss">
@import '~vuetify/src/styles/styles.sass';

.gif-create {
  position: absolute;
  right: 150px;
  top: 590px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 180px;
  height: 180px;
  padding-top: 15px;

  background: #00f1b8;
  border: 2px solid #000000;
  border-radius: calc(180px / 2);

  color: #1d1d1b !important;
  font-size: 30px;
  line-height: 1.2;
  text-align: center;
  text-decoration: none;

  transform: rotate(16deg);
  transition: transform 0.2s;

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    top: auto;
    bottom: -30px;
    right: 20px;
    width: 120px;
    height: 120px;
    padding-top: 8px;

    font-size: 18px;
  }

  &:hover {
    transform: rotate(8deg) scale(1.1);
  }
}

.gif-create-loader {
  margin-top: -10px;
}
</style>
